module.exports = __webpack_public_path__ + "img/slack.6fc22198.png";